const suppliers = [
  'Getränke Preiss Münchhagen GmbH',
  'Lehmann',
  'Außerordentliche Lieferungen',
];
export async function createExampleSuppliers(store: any) {
  const existing = store.peekAll('supplier');
  if (existing.length > 0) {
    return false;
  }
  for (const supplier of suppliers) {
    await store
      .createRecord('supplier', {
        name: supplier,
        active: true,
        additional:
          supplier === 'Außerordentliche Lieferungen' ? 'special' : undefined,
        company: store.peekRecord('company', 1),
        created_by: store.peekRecord('user', 1),
        updated_by: store.peekRecord('user', 1),
      })
      .save();
  }
}
